import React, {createContext} from 'react';

const default_value = {
 toasts: {}
};

export const ToastsContext = createContext(default_value);